import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import webAPI from "../../api/webApi";
import { showError, showSuccess, showWarning } from "../../utils/toastUtils";
import useNumericInput from "../../hooks/useNumericInput";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import gameAPI from "../../api/admin/gameApi";
import { MultiSelect } from "react-multi-select-component";
import CustomCaptcha from "../../layout/admin/partials/CustomCaptcha";
import commonAPI from "../../api/admin/commonApi";

function Registration() {
  useNumericInput();
  useAlphabeticInput();
  const { t } = useTranslation();

  const [gameList, setGameList] = useState([]);
  const [individualGames, setIndividualGames] = useState([]);
  const [teamGames, setTeamGames] = useState([]);
  const [vidhanSabhaList, setVidhanSabhaList] = useState([]);
  const [players, setPlayers] = useState([
    { name: "", phone: "", address: "" },
  ]);

  const [captchaVerified, setCaptchaVerified] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    gender: "",
    disability: false,
    mobile: "",
    email: "",
    address: "",
    pincode: "",
    state: "",
    district: "",
    postOfficeDropdown: [],
    postOffice: "",
    teamSports: [],
    individualSports: [],
    declaration: false,
    agreement: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handlePlayerChange = (index, field, value) => {
    const updatedPlayers = [...players];
    updatedPlayers[index][field] = value;
    setPlayers(updatedPlayers);
  };

  const addRow = () => {
    setPlayers([...players, { name: "", phone: "", address: "" }]);
  };

  const removeRow = (index) => {
    const updatedPlayers = [...players];
    updatedPlayers.splice(index, 1);
    setPlayers(updatedPlayers);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "pincode") {
      if (value.length === 6) {
        fetchPincodeDetails(value);
      }
    }
  };

  useEffect(() => {
    fetchGameDetails();
  }, []);

  const fetchGameDetails = async () => {
    const payload = {
      id: sessionStorage.getItem("selectedGameId"),
    };
    const res = await gameAPI.detailsforRegistration(payload);

    if (res.code === 200) {
      const result = res.data;

      setIndividualGames(result.individual);
      setTeamGames(result.team);
    }
  };

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      mobile: sessionStorage.getItem("mobileNumber") || "",
    }));
  }, []);

  const fetchPincodeDetails = async (pincode) => {
    try {
      const res = await fetch(
        `https://api.postalpincode.in/pincode/${pincode}`
      );
      const data = await res.json();

      if (data[0].Status === "Success") {
        const result = data[0].PostOffice;
        setFormData((prev) => ({
          ...prev,
          postOfficeDropdown: result,
          state: result[0]?.State || "",
          // district: result[0]?.District || "",
          block: result[0]?.Block || "",
        }));

        fetchVidhanSabha(result[0].State);
      } else {
        setFormData((prev) => ({
          ...prev,
          postOfficeDropdown: [],
          state: "",
          district: "",
          block: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching pincode data:", error);
    }
  };

  const fetchVidhanSabha = async (stateId) => {
    const res = await commonAPI.vidhanSabhaList({ state: stateId });

    if (res.code === 200) {
      setVidhanSabhaList(res.data);
    }
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Please Enter your name";
    }

    if (!formData.dob) {
      newErrors.dob = "Date of Birth is required.";
    } else {
      const age =
        new Date().getFullYear() - new Date(formData.dob).getFullYear();
      if (age < 5) newErrors.dob = "You must be at least 5 years old.";
    }

    if (!formData.gender) {
      newErrors.gender = "Gender is required.";
    }

    if (!formData.mobile) {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }

    if (!formData.address.trim()) {
      newErrors.address = "Address is required.";
    }

    if (!formData.pincode) {
      newErrors.pincode = "Pincode is required.";
    } else if (!/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = "Enter a valid 6-digit pincode.";
    }

    if (!formData.state) {
      newErrors.state = "State is required.";
    }
    if (!formData.district) {
      newErrors.district = "Vidhan Sabha is required.";
    }
    if (!formData.block) {
      newErrors.block = "Region is required.";
    }

    if (!formData.postOffice) {
      newErrors.postOffice = "Post Office selection is required.";
    }

    if (!formData.declaration) {
      newErrors.declaration = "You must accept the declaration.";
    }

    if (!formData.agreement) {
      newErrors.agreement = "You must agree to be contacted.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    formData.stateId = localStorage.getItem("stateId");
    formData.constituencyId = localStorage.getItem("constituencyId");

    try {
      const res = await webAPI.register(formData);

      if (res.code === 200) {
        showSuccess(res.message);

        setFormData({
          name: "",
          dob: "",
          gender: "",
          disability: false,
          mobile: "",
          email: "",
          address: "",
          pincode: "",
          state: "",
          district: "",
          postOfficeDropdown: [],
          postOffice: "",
          teamSports: [],
          individualSports: [],
          declaration: false,
          agreement: false,
        });
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <div className="main-content mt-5 mb-5">
      <div className="container">
        <div className="bg-light-regis p-4 border rounded shadow-sm w-100 w-md-70 mx-auto">
          <h2 className="text-center mb-4">
            {t("title")} - {t("registration")}
          </h2>
          <form id="registrationform" onSubmit={handleSubmit}>
            <h5 className="mb-3">{t("personal_information")}</h5>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  {t("full_name")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  className="form-control only-alphabets"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <span className="invalid-feedback d-block">
                    {errors.name}
                  </span>
                )}
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">
                  {t("date_of_birth")} <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  name="dob"
                  className="form-control"
                  value={formData.dob}
                  onChange={handleChange}
                />
                {errors.dob && (
                  <span className="invalid-feedback d-block">{errors.dob}</span>
                )}
              </div>
              <div className="col-md-4 mb-3 drop-down">
                <label className="form-label">
                  {t("gender")} <span className="text-danger">*</span>
                </label>
                <select
                  name="gender"
                  className="form-select"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">{t("select_gender")}</option>
                  <option>{t("male")}</option>
                  <option>{t("female")}</option>
                  <option>{t("other")}</option>
                </select>
                {errors.gender && (
                  <span className="invalid-feedback d-block">
                    {errors.gender}
                  </span>
                )}
              </div>
            </div>

            <div className="form-check mb-4">
              <input
                className="form-check-input"
                type="checkbox"
                name="disability"
                checked={formData.disability}
                onChange={handleChange}
              />
              <label className="form-check-label fw-bold">
                {t("specially_abled")}
              </label>
            </div>

            <h5 className="mb-3">{t("contact_information")}</h5>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">
                  {t("mobile_number")} <span className="text-danger">*</span>
                </label>
                <input
                  type="tel"
                  name="mobile"
                  className="form-control only-numeric"
                  maxLength={10}
                  readOnly
                  value={formData.mobile}
                  onChange={handleChange}
                />
                {errors.mobile && (
                  <span className="invalid-feedback d-block">
                    {errors.mobile}
                  </span>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label">{t("email")}</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <span className="invalid-feedback d-block">
                    {errors.email}
                  </span>
                )}
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">
                {t("current_address")} <span className="text-danger">*</span>
              </label>
              <textarea
                name="address"
                className="form-control"
                rows={2}
                value={formData.address}
                onChange={handleChange}
              />
              {errors.address && (
                <span className="invalid-feedback d-block">
                  {errors.address}
                </span>
              )}
            </div>

            <h5 className="mb-3">{t("location")}</h5>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label className="form-label">
                  {t("pincode")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="pincode"
                  className="form-control only-numeric"
                  maxLength={6}
                  value={formData.pincode}
                  onChange={handleChange}
                />
                {errors.pincode && (
                  <span className="invalid-feedback d-block">
                    {errors.pincode}
                  </span>
                )}
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label">
                  {t("state")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="state"
                  className="form-control"
                  value={formData.state}
                  readOnly
                />
                {errors.state && (
                  <span className="invalid-feedback d-block">
                    {errors.state}
                  </span>
                )}
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label">
                  Vidhan Sabha <span className="text-danger">*</span>
                </label>

                <select
                  name="district"
                  className="form-select"
                  value={formData.district}
                  onChange={handleChange}
                >
                  <option value="">Select Vidhan Sabha</option>
                  {vidhanSabhaList.map((office, index) => (
                    <option key={index} value={office.vidhansabha}>
                      {office.vidhansabha}
                    </option>
                  ))}
                </select>

                {/* <input
                  type="text"
                  name="district"
                  className="form-control"
                  value={formData.district}
                /> */}
                {errors.district && (
                  <span className="invalid-feedback d-block">
                    {errors.district}
                  </span>
                )}
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label">
                  {t("block")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="block"
                  className="form-control"
                  value={formData.block}
                  readOnly
                />
                {errors.block && (
                  <span className="invalid-feedback d-block">
                    {errors.block}
                  </span>
                )}
              </div>
            </div>

            <div className="mb-3 drop-down">
              <label className="form-label">{t("post_office")}</label>
              <select
                name="postOffice"
                className="form-select"
                value={formData.postOffice}
                onChange={handleChange}
              >
                <option value="">{t("select_post_office")}</option>
                {formData.postOfficeDropdown.map((office, index) => (
                  <option key={index} value={office.Name}>
                    {office.Name}
                  </option>
                ))}
              </select>
              {errors.postOffice && (
                <span className="invalid-feedback d-block">
                  {errors.postOffice}
                </span>
              )}
            </div>

            <div className="row">
              <p className="text-muted mb-3">
                <b>{t("note")} </b> <br />
                👉 {t("note_1")}
                <br />
                👉 {t("note_2")}
                <br />
                👉 {t("note_3")}
              </p>

              <div className="col-md-6 mb-3">
                <label className="form-label">
                  {t("individual_games")} <span className="text-danger">*</span>
                </label>

                <MultiSelect
                  options={individualGames.map((g) => ({
                    label: g.name,
                    value: g._id,
                  }))}
                  value={individualGames
                    .filter((g) => formData.individualSports.includes(g._id))
                    .map((g) => ({
                      label: g.name,
                      value: g._id,
                    }))}
                  onChange={(selected) => {
                    if (formData.teamSports.length > 0) {
                      showWarning(
                        "Team game already selected. You cannot select individual games."
                      );
                      return;
                    }
                    setFormData((prev) => ({
                      ...prev,
                      individualSports: selected.map((s) => s.value),
                    }));
                  }}
                  labelledBy="Select Game"
                  disable={formData.teamSports.length > 0}
                />
                {errors.venue && (
                  <span className="invalid-feedback d-block">
                    {errors.venue}
                  </span>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">
                  {t("team_games")} <span className="text-danger">*</span>
                </label>
                <span className="text-danger error" id="email_error" />

                <MultiSelect
                  options={teamGames.map((g) => ({
                    label: g.name,
                    value: g._id,
                  }))}
                  value={teamGames
                    .filter((g) => formData.teamSports.includes(g._id))
                    .map((g) => ({
                      label: g.name,
                      value: g._id,
                    }))}
                  onChange={(selected) => {
                    if (formData.individualSports.length > 0) {
                      showWarning(
                        "Individual games already selected. You cannot select a team game."
                      );
                      return;
                    }

                    if (selected.length > 1) {
                      showWarning("You can select only one team game.");
                      return;
                    }

                    setFormData((prev) => ({
                      ...prev,
                      teamSports: selected.map((s) => s.value),
                    }));
                  }}
                  labelledBy="Select Game"
                  disable={formData.individualSports.length > 0}
                />

                {errors.venue && (
                  <span className="invalid-feedback d-block">
                    {errors.venue}
                  </span>
                )}
              </div>
            </div>

            <div className="row">
              <div className="mb-3">
                {formData.teamSports.length > 0 && (
                  <div className="row mt-3">
                    <h5>Team Members</h5>
                    {players.map((player, index) => (
                      <div className="row mb-2" key={index}>
                        <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                            value={player.name}
                            onChange={(e) =>
                              handlePlayerChange(index, "name", e.target.value)
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Phone"
                            value={player.phone}
                            onChange={(e) =>
                              handlePlayerChange(index, "phone", e.target.value)
                            }
                          />
                        </div>
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Address"
                            value={player.address}
                            onChange={(e) =>
                              handlePlayerChange(
                                index,
                                "address",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-md-2">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => removeRow(index)}
                            disabled={players.length === 1}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    ))}
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addRow}
                      >
                        + Add Member
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <h5 className="mt-3 mb-2">{t("declarations")}</h5>

            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                name="declaration"
                checked={formData.declaration}
                onChange={handleChange}
              />
              <label className="form-check-label">
                {t("declaration_text1")}
              </label>
              <br />
              {errors.declaration && (
                <span className="invalid-feedback d-block">
                  {errors.declaration}
                </span>
              )}
            </div>

            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                name="agreement"
                checked={formData.agreement}
                onChange={handleChange}
              />
              <label className="form-check-label">
                {t("declaration_text2")}
              </label>
              <br />
              {errors.agreement && (
                <span className="invalid-feedback d-block">
                  {errors.agreement}
                </span>
              )}
            </div>

            <CustomCaptcha onVerify={setCaptchaVerified} />

            <button type="submit" className="btn btn-primary">
              {t("submit")}
            </button>
          </form>

          <p className="mt-3">
            <h5 className="mt-3 mb-2">{t("disclamer_note")}</h5>{" "}
            {t("disclamer_text")}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Registration;
